import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TableTemplate from "../../../newMediaMatrix/components/TableTemplate/TableTemplate";
import TransferPosition from "./TransferPosition";
import HistoricalRelease from './historicalRelease/historicalRelease';
import GetPosition from "./getPosition";
import {generateColumns} from "../../../newMediaMatrix/components/utils";
import noImg from "../../images/noImg.png";
import {formatToDay} from "../../../../utils";

/**
 * creat by tianruojun
 * @description 列表形式
 */
export default class PositionList extends Component {
    static propTypes = {
        listData: PropTypes.array,
        key: PropTypes.string,
    };
    static defaultProps = {
        key: 'positionList'
    };

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    getColumns() {
        const {refreshList, clickItem, activityTypeData, typeData = []} = this.props;
        const baseColumns = [
            {
                title: "账号名称",
                dataIndex: "name",
                key: "name",
                width: 250,
                ellipsis: true,
                render: (text, record, index) => {
                    return <div
                        style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            color: "#1890ff",
                            cursor: "pointer"
                        }}
                        title={text} onClick={() => clickItem(record)}>
                        <img style={{
                            width: 16,
                            height: 16,
                            objectFit: "cover",
                            verticalAlign: "text-bottom",
                            marginRight: 5
                        }} src={record.logo}/>{text}
                    </div>
                }
            },
            {
                title: "媒体平台",
                dataIndex: "positionTypeName",
                key: "positionTypeName",
                width: 150,
                render: (text, record, index) => {
                    let typeItem = typeData.length && typeData.find(item => item.id === record.positionTypeId);
                    return <div title={text}
                                style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                        <img style={{
                            width: 16,
                            height: 16,
                            objectFit: "cover",
                            verticalAlign: "text-bottom",
                            marginRight: 5
                        }} src={typeItem?.logo || noImg}/>{text}
                    </div>
                }
            },
            {
                title: "主责单位",
                dataIndex: "mainDeptName",
                key: "mainDeptName",
                ellipsis: true
            },
            {
                title: "账号状态",
                dataIndex: "statusName",
                key: "statusName",
                ellipsis: true
            },
            {
                title: "备案状态",
                dataIndex: "status",
                key: "status",
                ellipsis: true
            },
            {
                title: "创建人",
                dataIndex: "belongUserName",
                key: "belongUserName",
                ellipsis: true,
                render: (text, record) => {
                    return <div style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}
                                title={text ? text : ""}>{text ? text : "-"}</div>
                }
            },
            {
                title: "所属部门",
                dataIndex: "belongDeptName",
                key: "belongDeptName",
                ellipsis: true
            },
            {
                title: "操作",
                dataIndex: "operation",
                key: "operation",
                render: (text, record) => {
                    let operate = <>
                        <span style={{marginRight: 10}}><HistoricalRelease item={record} styleOut={{color: "#1890ff"}} /></span>
                        <TransferPosition styleOut={{color: "#1890ff"}} refreshList={() => refreshList()} item={record}/>
                    </>;
                    let isCurrentDept = record.belongDeptId === window.currentUser?.defaultInfo?.dept?.id; //是否当前部门
                    if(record.processType === 5 && window.currentUser.id !== record.belongUserAccount && isCurrentDept) {
                        operate = <>
                            <GetPosition styleOut={{color: "#1890ff"}} item={record} clickItem={clickItem}/>
                        </>
                    }
                    return operate;
                }
            }
        ];
        const dynamicColumns = [
            {
                key: 'annualAuditTime',
                dataIndex: "annualAuditTime",
                ellipsis: true,
                title: '最新年审时间',
                checkFunction: () => activityTypeData.some(record => record.type === 4 && record.status === 1),
                position: 5,
                render: (text, record) => {
                    return <div
                        title={record.annualAuditTime ? formatToDay(record.annualAuditTime) : ""}>{record.annualAuditTime ? formatToDay(record.annualAuditTime) : "-"}</div>
                }
            }
        ];
        return generateColumns(baseColumns, dynamicColumns, activityTypeData)
    }

    transfer(record) {
        this.props.transferPosition(record)
    }

    render() {
        const {listData, tabKey} = this.props;
        const columns = this.getColumns();
        return (
            <>
                <TableTemplate
                    key={"TableTemplate" + tabKey}
                    columns={columns}
                    dataSource={listData}
                    onResize={(offsetHeight) => {}}
                />
            </>
        )
    }
}